import { mapEnumToOptions } from '@abp/ng.core';

export enum SOPReportType {
  Email = 0,
  Export = 1,
  Checklist = 2,
}

export const sopReportTypeOptions = mapEnumToOptions(SOPReportType);
